import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
import { MetadataInputOption, ModelTemplate } from "../metadata/types";
import { State } from "../state";
import { EntityDropdownOption, UploadSuccessParams } from "./types";

const create = actionCreatorFactory("UploadFinancialDocument");
const createAsync = asyncFactory<State>(create);

export interface UploadParams {
  formData: FormData;
}

export const uploadFinancialDocument = createAsync<
  UploadParams,
  UploadSuccessParams
>("UPLOAD", async (params, dispatch, getState) => {
  dispatch({
    payload: { lastUsed: new Date().getTime().toString() },
    type: "UPDATE_LAST_USED"
  });
  return await api.uploadFinancialDocument.post(params.formData);
});
const uploadFinancialDocumentAction = thunkToAction(
  uploadFinancialDocument.action
);
export type UploadFinancialDocumentActionType = typeof uploadFinancialDocumentAction;

export type SearchEntitiesParams = string;

export interface ChangeParams {
  [key: string]:
    | string
    | number
    | File
    | Date
    | boolean
    | EntityDropdownOption
    | ModelTemplate
    | MetadataInputOption;
}

export const onUploadFormChange = create<ChangeParams>("UPLOAD_FORM_CHANGE");

export const resetUpload = create("RESET_UPLOAD");



// WEBPACK FOOTER //
// ./src/documentUpload/actions.ts